import { defineStore } from 'pinia';

export const useInfoStore = defineStore('info ', {
    state: () => ({
        faqData: null,
        offerData: null,
        coupanData: null,
        settlementData: null,
        cityData:null,
    }),
    actions: {
        setFaqData() {
            if (
                localStorage.getItem("faq_edit_data") &&
                localStorage.getItem("faq_edit_data").toString().length > 0
            ) {
                this.faqData = JSON.parse(localStorage.getItem("faq_edit_data").toString());
            }
        },
        setOfferData() {
            if (
                localStorage.getItem("offer_edit_data") &&
                localStorage.getItem("offer_edit_data").toString().length > 0
            ) {
                this.offerData = JSON.parse(localStorage.getItem("offer_edit_data").toString());
            }
        },
        setCoupanData() {
            if (
                localStorage.getItem("coupan_edit_data") &&
                localStorage.getItem("coupan_edit_data").toString().length > 0
            ) {
                this.coupanData = JSON.parse(localStorage.getItem("coupan_edit_data").toString());
            }
        },
        setSettlementData() {
            if (
                localStorage.getItem("settlement_edit_data") &&
                localStorage.getItem("settlement_edit_data").toString().length > 0
            ) {
                this.settlementData = JSON.parse(localStorage.getItem("settlement_edit_data").toString());
            }
        },
        setCityData() {
            if (
                localStorage.getItem("city_edit_data") &&
                localStorage.getItem("city_edit_data").toString().length > 0
            ) {
                this.cityData = JSON.parse(localStorage.getItem("city_edit_data").toString());
            }
        }
    },

    getters: {}
});
